import { render, staticRenderFns } from "./model-logs-list.vue?vue&type=template&id=6ac95aef&scoped=true"
import script from "./model-logs-list.vue?vue&type=script&lang=js"
export * from "./model-logs-list.vue?vue&type=script&lang=js"
import style0 from "./model-logs-list.vue?vue&type=style&index=0&id=6ac95aef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac95aef",
  null
  
)

export default component.exports